import React from 'react';
import {
  Box,
  Typography,
  useTheme
} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const CustomerService = () => {
  const theme = useTheme();

  const qrCodeSrc = '/images/support_qrcode.png';
  const primaryColor = theme.palette.primary.main;

  return (
    <Box sx={{ height: '100%' }}>
      {/* 页面标题 */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 600,
            background: 'linear-gradient(90deg, #4353FF 0%, #4353FF 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginLeft: '10px',
            mb: 1
          }}
        >
          专属客服
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ marginLeft: '10px' }}
        >
          扫码添加客服微信，获取一对一专属服务
        </Typography>
      </Box>

      {/* 客服信息卡片 */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6
        }}
      >
        {/* 二维码区域 */}
        <Box
          sx={{
            width: 280,
            height: 280,
            mx: 'auto',
            mb: 4,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            p: 2,
            backgroundColor: 'white',
            boxShadow: '0 8px 32px rgba(67, 83, 255, 0.15)',
            border: `1px solid ${primaryColor}20`
          }}
        >
          <img
            src={qrCodeSrc}
            alt="客服微信二维码"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '12px'
            }}
          />
        </Box>

        {/* 标题 */}
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, mb: 1, color: primaryColor }}
        >
          扫码添加客服微信
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 3, color: 'text.secondary', textAlign: 'center' }}
        >
          专业客服为您提供一对一咨询和认证服务
        </Typography>

        {/* 服务时间 */}
        <Box sx={{
          backgroundColor: primaryColor + '10',
          borderRadius: 3,
          p: 3,
          textAlign: 'center',
          border: `1px dashed ${primaryColor}30`,
          minWidth: 300
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
            <SupportAgentIcon sx={{ color: primaryColor, fontSize: 24 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: primaryColor }}>
              服务时间
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            周一至周日 9:00-21:00
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerService;
